import styled from 'styled-components';

const SearchResultsHeader = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin: 0 0 20px 0;
`;

export default SearchResultsHeader;


// WEBPACK FOOTER //
// ./src/components/searchResults/components/searchResultsHeader.js